// extracted by mini-css-extract-plugin
export default {"aboutContainer":"styles_aboutContainer__P-hdA","aboutTitle":"styles_aboutTitle__FZbs8"};